<fieldset class="border rounded-3 p-3">
  <legend class="subtitle-4 float-none w-auto px-3">
    Internal pressure only, loadings such as wind and earthquake are not
    considered.
  </legend>
  <div *ngIf="validationList.length > 0">
    <validation
      [ValidationList]="validationList"
      [ValidationLabel]="validationListLabel"
    ></validation>
    <br />
  </div>
  <div class="container">
    <form [formGroup]="mawpForm">
      <div class="form-group row align-items-center">
        <div class="col-sm-8 align-self-center">
          <label for="selectedComponentType">Component type:</label>
        </div>
        <div class="col-sm-4">
          <select
            id="selectedComponentType"
            formControlName="selectedComponentType"
            class="form-control form-control-sm"
            name="selectedComponentType"
            (change)="onComponentTypeChange($event.target.value)"
          >
            <option value="-1">Select Type</option>
            <option
              *ngFor="let data of ComponentTypeData"
              [value]="data.value"
              [hidden]="data.value === '-1'"
            >
              {{ data.text }}
            </option>
          </select>
        </div>
      </div>
      <div>
        <div class="form-group row align-items-center">
          <div class="col-sm-8 align-self-center">
            <label
              class="float-left"
              for="textBox2_MAWP"
              *ngIf="[-1, 0, 1, 2].indexOf(componentMAWP.intEquip) !== -1"
              >Original inside diameter, D&nbsp;<span *ngIf="this.intUnit === 0"
                >(inch)</span
              ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
            >
            <label
              class="float-left"
              for="textBox2_MAWP"
              *ngIf="[4].indexOf(componentMAWP.intEquip) !== -1"
              >Crown radius, Cr of the spherical section&nbsp;<span
                *ngIf="this.intUnit === 0"
                >(inch)</span
              ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
            >
            <label
              class="float-left"
              for="textBox2_MAWP"
              *ngIf="[5,6,7].indexOf(componentMAWP.intEquip) !== -1"
              >Original outside diameter, OD&nbsp;<span
                *ngIf="this.intUnit === 0"
                >(inch)</span
              ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
            >
            <label
              class="float-left"
              for="sngID"
              *ngIf="[3].indexOf(componentMAWP.intEquip) !== -1"
              >Inside diameter of head straight flange, D&nbsp;<span
                *ngIf="this.intUnit === 0"
                >(inch)</span
              ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
            >
          </div>
          <div class="col-sm-4">
            <input
              class="float-right"
              type="number"
              labelDisable
              appRestrictInput
              id="textBox2_MAWP"
              formControlName="textBox2_MAWP"
              name="textBox2_MAWP"
              class="form-control form-control-sm"
              (change)="textBox2_MAWP_TextChanged($event.target.value)"
              min="0"
            />
          </div>
        </div>
        <div class="form-group row align-items-center">
          <div class="col-sm-8 align-self-center">
            <label for="textBox3_MAWP"
              >Original nominal thickness, tnom&nbsp;<span
                *ngIf="this.intUnit === 0"
                >(inch)</span
              ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
            >
          </div>
          <div class="col-sm-4">
            <input
              type="number"
              labelDisable
              appRestrictInput
              id="textBox3_MAWP"
              formControlName="textBox3_MAWP"
              name="textBox3_MAWP"
              class="form-control form-control-sm"
              (change)="textBox3_MAWP_TextChanged($event.target.value)"
              min="0"
            />
          </div>
        </div>
        <div class="form-group row align-items-center">
          <div class="col-sm-8 align-self-center">
            <label for="textBox4_MAWP"
              >Current uniform metal loss (internal), LOSSi&nbsp;<span
                *ngIf="this.intUnit === 0"
                >(inch)</span
              ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
            >
          </div>
          <div class="col-sm-4">
            <input
              type="number"
              labelDisable
              appRestrictInput
              id="textBox4_MAWP"
              formControlName="textBox4_MAWP"
              name="textBox4_MAWP"
              class="form-control form-control-sm"
              (change)="textBox4_MAWP_TextChanged($event.target.value)"
              min="0"
            />
          </div>
        </div>
        <div class="form-group row align-items-center">
          <div class="col-sm-8 align-self-center">
            <label for="textBox5_MAWP"
              >Current uniform metal loss (external), LOSSe&nbsp;<span
                *ngIf="this.intUnit === 0"
                >(inch)</span
              ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
            >
          </div>
          <div class="col-sm-4">
            <input
              type="number"
              labelDisable
              appRestrictInput
              id="textBox5_MAWP"
              formControlName="textBox5_MAWP"
              name="textBox5_MAWP"
              class="form-control form-control-sm"
              (change)="textBox5_MAWP_TextChanged($event.target.value)"
              min="0"
            />
          </div>
        </div>
        <div class="form-group row align-items-center">
          <div class="col-sm-8 align-self-center">
            <label for="textBox6_MAWP"
              >Future corrosion allowance (internal), FCAi&nbsp;<span
                *ngIf="this.intUnit === 0"
                >(inch)</span
              ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
            >
          </div>
          <div class="col-sm-4">
            <input
              type="number"
              labelDisable
              appRestrictInput
              id="textBox6_MAWP"
              formControlName="textBox6_MAWP"
              name="textBox6_MAWP"
              class="form-control form-control-sm"
              (change)="textBox6_MAWP_TextChanged($event.target.value)"
              min="0"
            />
          </div>
        </div>
        <div class="form-group row align-items-center">
          <div class="col-sm-8 align-self-center">
            <label for="textBox7_MAWP"
              >Future corrosion allowance (external), FCAe&nbsp;<span
                *ngIf="this.intUnit === 0"
                >(inch)</span
              ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
            >
          </div>
          <div class="col-sm-4">
            <input
              type="number"
              labelDisable
              appRestrictInput
              id="textBox7_MAWP"
              formControlName="textBox7_MAWP"
              name="textBox7_MAWP"
              class="form-control form-control-sm"
              (change)="textBox7_MAWP_TextChanged($event.target.value)"
              min="0"
            />
          </div>
        </div>
        <div class="form-group row align-items-center">
          <div class="col-sm-8 align-self-center">
            <label for="textBox8_MAWP"
              >Equipment design pressure or vessel MAWP, P_d&nbsp;<span
                *ngIf="this.intUnit === 0"
                >(psi)</span
              ><span *ngIf="this.intUnit === 1">(MPa)</span>:</label
            >
          </div>
          <div class="col-sm-4">
            <input
              type="number"
              labelDisable
              appRestrictInput
              id="textBox8_MAWP"
              formControlName="textBox8_MAWP"
              name="textBox8_MAWP"
              class="form-control form-control-sm"
              (change)="textBox8_MAWP_TextChanged($event.target.value)"
              min="0"
            />
          </div>
        </div>
        <div class="form-group row align-items-center" *ngIf="componentMAWP.intEquip !== 6 && componentMAWP.intEquip !== 7">
          <div class="col-sm-8 align-self-center">
            <label for="textBox9_MAWP"
              >Allowable stress at design temperature, S&nbsp;<span
                *ngIf="this.intUnit === 0"
                >(psi)</span
              ><span *ngIf="this.intUnit === 1">(MPa)</span>:</label
            >
          </div>
          <div class="col-sm-4">
            <input
              type="number"
              labelDisable
              appRestrictInput
              id="textBox9_MAWP"
              formControlName="textBox9_MAWP"
              name="textBox9_MAWP"
              class="form-control form-control-sm"
              (change)="textBox9_MAWP_TextChanged($event.target.value)"
              min="0"
            />
          </div>
        </div>
         <div class="form-group row align-items-center" *ngIf="[6,7].indexOf(componentMAWP.intEquip) !== -1">
          <div class="col-sm-8 align-self-center">
            <label for="textBox17_MAWP"
              >Specified minimum yield strength, Sy
              <span *ngIf="this.intUnit === 1">(MPa)</span> <span *ngIf="this.intUnit === 0">(psi)</span>:
              </label>
          </div>
          <div class="col-sm-4">
            <input
              type="number"
              labelDisable
              appRestrictInput
              id="textBox17_MAWP"
              formControlName="textBox17_MAWP"
              name="textBox17_MAWP"
              class="form-control form-control-sm"
              (change)="textBox17_MAWP_TextChanged($event.target.value)"
              min="0"
            />
          </div>
        </div>


        <div class="form-group row align-items-center">
          <div class="col-sm-8 align-self-center">
            <label for="textBox10_MAWP"
              >Longitudinal weld joint efficiency, E_L:</label
            >
          </div>
          <div class="col-sm-4">
            <input
              type="number"
              labelDisable
              appRestrictInput
              id="textBox10_MAWP"
              formControlName="textBox10_MAWP"
              name="textBox10_MAWP"
              class="form-control form-control-sm"
              (change)="textBox10_MAWP_TextChanged($event.target.value)"
              min="0"
            />
          </div>
        </div>
        <div class="form-group row align-items-center">
          <div class="col-sm-8 align-self-center">
            <label for="textBox11_MAWP"
              >Circumferential weld joint efficiency, E_C:</label
            >
          </div>
          <div class="col-sm-4">
            <input
              type="number"
              labelDisable
              appRestrictInput
              id="textBox11_MAWP"
              formControlName="textBox11_MAWP"
              name="textBox11_MAWP"
              class="form-control form-control-sm"
              (change)="textBox11_MAWP_TextChanged($event.target.value)"
              min="0"
            />
          </div>
        </div>

        <div class="form-group row align-items-center">
          <div
            class="col-sm-8 align-self-center"
            *ngIf="[-1, 0, 1, 2, 3].indexOf(componentMAWP.intEquip) !== -1"
          >
            <label for="textBox12_MAWP"
              >Apex angle for conical shell, Alpha&nbsp;<span
                *ngIf="this.intUnit === 0"
                >(degree)</span
              ><span *ngIf="this.intUnit === 1">(degree)</span>:</label
            >
          </div>
          <div
            class="col-sm-8 align-self-center"
            *ngIf="[4].indexOf(componentMAWP.intEquip) !== -1"
          >
            <label for="textBox12_MAWP"
              >Kunckle radius, rk&nbsp;<span *ngIf="this.intUnit === 0"
                >(inch)</span
              ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
            >
          </div>
          <div
            class="col-sm-8 align-self-center"
            *ngIf="[5].indexOf(componentMAWP.intEquip) !== -1"
          >
            <label for="textBox12_MAWP">B31.3 Y factor:</label>
          </div>

           <div
            class="col-sm-8 align-self-center"
            *ngIf="[6,7].indexOf(componentMAWP.intEquip) !== -1"
          >
            <label for="textBox12_MAWP">Design factor, F:</label>
          </div>

          <div class="col-sm-4">
            <input
              type="number"
              labelDisable
              appRestrictInput
              id="textBox12_MAWP"
              formControlName="textBox12_MAWP"
              name="textBox12_MAWP"
              class="form-control form-control-sm"
              (change)="textBox12_MAWP_TextChanged($event.target.value)"
              min="0"
            />
          </div>
        </div>
        
         <div class="form-group row align-items-center" *ngIf="[7].indexOf(componentMAWP.intEquip) !== -1">
          <div class="col-sm-8 align-self-center">
            <label for="textBox18_MAWP"
              >Temperature derating factor, T:</label
            >
          </div>
          <div class="col-sm-4">
            <input
              type="number"
              labelDisable
              appRestrictInput
              id="textBox18_MAWP"
              formControlName="textBox18_MAWP"
              name="textBox18_MAWP"
              class="form-control form-control-sm"
              (change)="textBox18_MAWP_TextChanged($event.target.value)"
              min="0"
            />
          </div>
        </div>
        
        <div class="form-group row align-items-center">
          <div class="col-sm-8 align-self-center">
            <label for="textBox13_MAWP"
              >Required axial thickness for supplemental loads, t_sl&nbsp;<span
                *ngIf="this.intUnit === 0"
                >(inch)</span
              ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
            >
          </div>
          <div class="col-sm-4">
            <input
              type="number"
              labelDisable
              appRestrictInput
              id="textBox13_MAWP"
              formControlName="textBox13_MAWP"
              name="textBox13_MAWP"
              class="form-control form-control-sm"
              (change)="textBox13_MAWP_TextChanged($event.target.value)"
              min="0"
            />
          </div>
        </div>
        <div class="form-group row align-items-center">
          <div class="col-sm-8 align-self-center">
            <label for="textBox14_MAWP"
              >Liquid head height, H_L&nbsp;<span *ngIf="this.intUnit === 0"
                >(feet)</span
              ><span *ngIf="this.intUnit === 1">(m)</span>:</label
            >
          </div>
          <div class="col-sm-4">
            <input
              type="number"
              labelDisable
              appRestrictInput
              id="textBox14_MAWP"
              formControlName="textBox14_MAWP"
              name="textBox14_MAWP"
              class="form-control form-control-sm"
              (change)="textBox14_MAWP_TextChanged($event.target.value)"
              min="0"
            />
          </div>
        </div>
        <div class="form-group row align-items-center">
          <div class="col-sm-8 align-self-center">
            <label for="textBox15_MAWP">Specific gravity, s_g:</label>
          </div>
          <div class="col-sm-4">
            <input
              type="number"
              labelDisable
              appRestrictInput
              id="textBox15_MAWP"
              formControlName="textBox15_MAWP"
              name="textBox15_MAWP"
              class="form-control form-control-sm"
              (change)="textBox15_MAWP_TextChanged($event.target.value)"
              min="0"
            />
          </div>
        </div>
        <div class="form-group row align-items-center">
          <div class="col-sm-8 align-self-center">
            <label for="textBox16_MAWP"
              >Allowable Remaining Strength Factor, RSFa (default = 0.9):</label
            >
          </div>
          <div class="col-sm-4">
            <input
              type="number"
              appRestrictInput
              id="textBox16_MAWP"
              formControlName="textBox16_MAWP"
              name="textBox16_MAWP"
              class="form-control form-control-sm"
              (change)="textBox16_MAWP_TextChanged($event.target.value)"
              min="0"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
</fieldset>
